import React from 'react';
import { Fragment } from 'react';
import { Helmet } from 'react-helmet-async';
import { Link } from 'react-router-dom';
import { WordShape, UserShape, TackShape, NavigationShape } from '../../shapes';
import WordBody from './word_body';
import PropTypes from 'prop-types';
import WordHeader from './header';

export default class Word extends React.Component {
  static propTypes = {
    word: WordShape,
    user: UserShape,
    tack: TackShape,
    navigation: NavigationShape,
    loadComments: PropTypes.bool,
    params: PropTypes.object,
    onFetchWord: PropTypes.func,
    onResetTack: PropTypes.func,
    onResetWord: PropTypes.func,
    onFetchTack: PropTypes.func,
    onSetAfterTackPath: PropTypes.func
  }

  componentDidMount() {
    if (this.props.word.get('wordText') !== this.props.params.wordText){
      this.props.onResetTack();
      this.props.onResetWord();
      this.props.onFetchWord(this.props.params.wordText, this.props.params.targetLanguage);
      this.props.onFetchTack(this.props.params.wordText);
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps == undefined) {
      return false;
    }

    if (this.props.params.targetLanguage !== prevProps.params.targetLanguage) {
      this.props.onFetchWord(this.props.params.wordText, this.props.params.targetLanguage);
    }

    if (this.props.navigation.get('lastPathname') && !(this.props.navigation.get('lastPathname') === this.props.navigation.get('afterTackPathname'))) {
      this.props.onSetAfterTackPath(this.props.navigation.get('lastPathname'));
    }
  }

  render() {
    return (
      <div className='word'>
        <WordHeader wordText={ this.props.params.wordText } pronunciationFile={ this.props.word.get('pronunciationFile') } partOfSpeech={ this.props.word.get('partOfSpeech') } />
        { this.renderBody() }
      </div>
    );
  }

  renderBody() {
    if (this.props.word.get('error')) {
      return this.renderRetrievalError();
    } else {
      return (
        <Fragment>
          <Helmet>
            <title>{ this.props.word.get('wordText') }</title>
            <meta name="description" content={ this.props.word.get('definitions').first() }></meta>
            <meta name="og:description" content={ this.props.word.get('definitions').first() }></meta>
            <meta name="og:url" content={ window.location.href }></meta>
            <meta name="og:title" content={ this.props.word.get('wordText') }></meta>
          </Helmet>
          <WordBody
            user={ this.props.user}
            word={ this.props.word }
            tack={ this.props.tack }
            targetLanguage={ this.props.params.targetLanguage }
            navigation={ this.props.navigation }
            loadComments={ this.props.loadComments }
          />
        </Fragment>
      );
    }
  }

  renderRetrievalError() {
    return(
      <div className='error'>
        Hmm, we had a problem looking up <b>{ `"${ this.props.params.wordText }."` }</b> <Link to='/'>Try again?</Link>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/word/index.jsx